import { Box, List, ListItem, ListItemText, Tooltip } from "@mui/material";

const Orgpath = ({ params }) => {
	return (
		<>
			<Box
				sx={{
					width: "100%",
					display: "grid",
					placeItems: "center",
					alignItems: "center",
					alignContent: "center",
					gap: "10px",
					p: 1.5,
					height: "100%",
				}}
			>
				<List sx={{ width: "100%" }} dense={true}>
					{params?.value?.map((orgpath) => (
						<ListItem key={orgpath.hiring_orgpath_id}>
							<ListItemText
								primary={
									<Tooltip
										title={`${orgpath?.Area?.sort(
											(a, b) => a.lvl - b.lvl
										)
											.map((o) => o.name)
											.join("/")}/${
											orgpath?.Posicion?.name
										}`}
									>
										{`${
											orgpath?.Area?.length > 1
												? "…/"
												: ""
										}${
											orgpath?.Area?.[
												orgpath?.Area.length - 1
											]?.name
										}/${orgpath?.Posicion?.name}`}
									</Tooltip>
								}
							/>
						</ListItem>
					))}
				</List>
			</Box>
		</>
	);
};

export { Orgpath };
